import React, { FC, useContext } from 'react'
import { Input } from 'antd'
import { FreeTextFilter } from '../types'
import {
    EditableViewContext,
    EditableViewInputWrapper,
} from '@pushly/aqe/lib/components/hoc/editable-view/editable-view-context'
import classnames from 'classnames'
import moment from 'moment-timezone'

type FreeTextInputFilterProps = {
    filter: FreeTextFilter
    onChange: (value: string) => void
}

export const FreeTextInputFilter: FC<FreeTextInputFilterProps> = ({ filter, onChange }) => {
    const viewCtx = useContext(EditableViewContext)
    return (
        <Input
            className={classnames(viewCtx.modeClassName, 'blueconic-free-text-input')}
            size="middle"
            value={filter.value}
            onChange={(ev) => {
                const value = ev.target.value
                onChange(value)
            }}
        />
    )
}
